<template lang="pug">
dv-checkbox(
  v-model="inputValue"
  v-bind="$attrs"
  v-on="$listeners"
)
  template(#label)
    span.body-2 Согласие на&nbsp;
      template(v-if="file")
        a(
          target="_blank"
          :href="file.url"
          @click.stop
        ).font-weight-medium.redesignPrimaryDarken--text {{ title }}
      template(v-else)
        | {{ title }}
</template>

<script>
import DvCheckbox from '@/packages/ui/components/inputs/DvCheckbox.vue';

export default {
  name: 'EventAgreementLink',
  components: {
    DvCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    file: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>
